import React from 'react'
import './AboutMe.css'


function AboutMe() {

  return (
    <div className='flex-center  bg-2 abt '>
      <div className='abt-left  flex-right'>
        <div className=''>
          <h1 className='text-64 abt-h1 color-bright'>ABOUT ME</h1>
          <h2 className='abt-h2 color-bright'>
            I'm very flexible in my programming profession, I can do backend, frontend, game development, cloud computing, blockchain, blender.
I have been learning Unity & C# since 2018
          </h2>
        </div>
      </div>
      <div className='abt-right'>
        
      </div>
    </div>
  )
}

export default AboutMe